import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { ApiResponse } from '@shared/models';
import { DivisionDto } from '@app/store/shared/models';
import { DivisionLookup, DivisionLookupDto, Divisions, GetDivisionsValue, GetDivisionsValueDto } from '../models';

@Service()
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getDivisions(value: GetDivisionsValue): Observable<Divisions> {
        const params = new GetDivisionsValueDto(value).toHttpParams();

        return this.httpClient.get<ApiResponse<DivisionDto[]>>('v1/admin/divisions', { params }).pipe(mapDto((response) => new Divisions(response)));
    }

    getDivisionsLookup(): Observable<DivisionLookup[]> {
        return this.httpClient
            .get<ApiResponse<DivisionLookupDto[]>>('v1/admin/divisions/lookup')
            .pipe(mapDto((response) => response.data.map((dto) => new DivisionLookup(dto))));
    }
}
